module.exports = __webpack_public_path__ + "img/profile-analyze.0e662de.svg";